import React from "react";
import { Row, Col, Button } from "reactstrap";
import { Icon } from "@material-ui/core";
import InputFeild from "../../../global/form/input";
import { FieldLabel, TagListInput, IconButton, SectionPanel, NestedRow } from "./common_controls";
import { buildEmptyMapping } from "./config_model";

export const DuplicateSection = ({ config, onChange, knownColumns }) => {
  const rules = config.duplicateConfiguration || [];
  const setRules = next => onChange({ ...config, duplicateConfiguration: next });

  const updateRule = (i, patch) => {
    const next = [...rules];
    next[i] = { ...next[i], ...patch };
    setRules(next);
  };
  const removeRule = i => setRules(rules.filter((_, idx) => idx !== i));
  const addRule = () => setRules([...rules, { where: "", priority: [] }]);

  return (
    <SectionPanel title="Duplicate Handling" helper="When the same task appears more than once in a report, keep the row whose column value has the highest priority below.">
      {rules.map((rule, i) => (
        <NestedRow key={i}>
          <Col xs={4}>
            <FieldLabel label="Column to check">
              <InputFeild placeholder="e.g. Status" list={knownColumns && knownColumns.length ? "dup_cols" : undefined} value={rule.where || ""} onChange={e => updateRule(i, { where: e.target.value })} />
            </FieldLabel>
          </Col>
          <Col>
            <FieldLabel label="Priority order (highest first)">
              <TagListInput values={rule.priority || []} onChange={arr => updateRule(i, { priority: arr })} placeholder="e.g. APPROVED" />
            </FieldLabel>
          </Col>
          <Col xs="auto">
            <IconButton icon="delete" danger onClick={() => removeRule(i)} title="Remove rule" />
          </Col>
        </NestedRow>
      ))}
      {knownColumns && knownColumns.length > 0 && (
        <datalist id="dup_cols">
          {knownColumns.map((c, i) => <option key={i} value={c} />)}
        </datalist>
      )}
      <Button size="sm" color="link" className="p-0 mt-1" onClick={addRule}><Icon fontSize="small" className="align-middle">add</Icon> Add duplicate-handling rule</Button>
    </SectionPanel>
  );
};

export const MailRoutingSection = ({ config, onChange, defaultFormId }) => {
  const mappings = config.mappings || [];
  const setMappings = next => onChange({ ...config, mappings: next });

  const updateMapping = (i, patch) => {
    const next = [...mappings];
    next[i] = { ...next[i], ...patch };
    setMappings(next);
  };
  const removeMapping = i => setMappings(mappings.filter((_, idx) => idx !== i));
  const addMapping = () => setMappings([...mappings, { ...buildEmptyMapping(), form_ids: defaultFormId ? [String(defaultFormId)] : [] }]);

  return (
    <SectionPanel title="Mail Routing" helper="Report emails from these client addresses will use this configuration for the listed Form IDs.">
      {mappings.map((mapping, i) => (
        <NestedRow key={mapping.id || i}>
          <Col md={4}>
            <FieldLabel label="Client email">
              <InputFeild placeholder="client@example.com" value={mapping.email_id || ""} onChange={e => updateMapping(i, { email_id: e.target.value })} />
            </FieldLabel>
          </Col>
          <Col md={4}>
            <FieldLabel label="Form IDs" helper="Job task form(s) this routing applies to.">
              <TagListInput values={mapping.form_ids || []} onChange={arr => updateMapping(i, { form_ids: arr })} placeholder={defaultFormId ? String(defaultFormId) : "Form ID"} />
            </FieldLabel>
          </Col>
          <Col md={3}>
            <FieldLabel label="Sheets (optional)" helper="Leave blank to apply to all sheets/tabs.">
              <TagListInput values={mapping.sheets || []} onChange={arr => updateMapping(i, { sheets: arr })} placeholder="Sheet name" />
            </FieldLabel>
          </Col>
          <Col md="auto" className="d-flex align-items-center">
            <IconButton icon="delete" danger onClick={() => removeMapping(i)} title="Remove routing" />
          </Col>
        </NestedRow>
      ))}
      <Button size="sm" color="link" className="p-0 mt-1" onClick={addMapping}><Icon fontSize="small" className="align-middle">add</Icon> Add another client email</Button>
    </SectionPanel>
  );
};

export const MetadataSection = ({ config }) => {
  if (!config.config_id) return null;
  return (
    <SectionPanel title="Configuration Metadata">
      <Row className="small text-muted">
        <Col md={6}>Created by: {config.created_by || "-"}</Col>
        <Col md={6}>Created: {config.created_on ? new Date(config.created_on).toLocaleDateString() : "-"}</Col>
        <Col md={6}>Last updated by: {config.modified_by || "-"}</Col>
        <Col md={6}>Last updated: {config.modified_on ? new Date(config.modified_on).toLocaleDateString() : "-"}</Col>
      </Row>
    </SectionPanel>
  );
};

export const StatusBadge = ({ isActive }) => {
  const active = isActive === "1" || isActive === 1;
  return (
    <span className={`d-inline-flex align-items-center ${active ? "text-success" : "text-muted"}`}>
      <span
        className="d-inline-block rounded-circle mr-1"
        style={{ width: 6, height: 6, backgroundColor: active ? "#28a745" : "#adb5bd" }}
      />
      {active ? "Active" : "Inactive"}
    </span>
  );
};
